/*
 * Layout for the response-related KB settings (touchPoints, locales, and contexts)
 */

define(["marionette", "./template/responseSettingsTemplate.html"], function (
  Marionette,
  ResponseSettingsTemplate,
) {
  var ResponseSettingsView = {
    responseSettingsLayout: Marionette.Layout.extend({
      template: ResponseSettingsTemplate,
      triggers: {
        "click #editLocale": "edit:locales",
        "click #editContext": "edit:contexts",
        "click #editTouchPoints": "edit:touchPoints",
      },
    }),
  };

  return ResponseSettingsView;
});
